import { useState, useEffect, Fragment } from "react";
import { TableAntd } from "../../components";
import { createColumns } from "./formatTable";
import { executeQuery } from "../../api/sistema";
import { notification, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useAuth } from "../../utils/useAuth";

function Lista(props) {
  const [dataToTable, setDataToTable] = useState([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { usuario } = useAuth();

  const fetchDataToTable = async () => {
    setIsLoading(true);

    executeQuery({
      query: "get_count_asistencias_registrador",
      collection: "pos_postulante",
      petitions: [{ name: "@DNIREGISTRADOR", value: usuario.nrodocumento || "", type: "string" }]
    })
      .then((res) => {
        setDataToTable(res.payload);
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchDataToTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const columnsToTable = createColumns();

  return (
    <Fragment>
      <span className="flex gap-2 items-center">
        <h1 className=" w-full my-4">
          Asistencias para registrador:
          <span className="font-bold">
            &nbsp;{usuario?.usuario || "Usuario"}&nbsp;
            <Button
              size="small"
              icon={<ReloadOutlined />}
              onClick={() => setReload(!reload)}
            ></Button>
          </span>
        </h1>
      </span>
      <TableAntd columns={columnsToTable} dataSource={dataToTable} isLoading={isLoading} />
      <div className="my-10" style={{ height: '40px' }}></div>
    </Fragment>
  );
}

export default Lista;
